const IPC_CHANNEL_NAME = 'voicetodo_ipc_channel';

let broadcastChannel = null;

export function getIPCChannel() {
  if (typeof window === 'undefined') return null;
  if (!broadcastChannel && 'BroadcastChannel' in window) {
    try {
      broadcastChannel = new BroadcastChannel(IPC_CHANNEL_NAME);
    } catch (e) {
      console.error('BroadcastChannel initialization error:', e);
    }
  }
  return broadcastChannel;
}

export function broadcastIPCEvent(type, payload = {}) {
  const channel = getIPCChannel();
  if (channel) {
    try {
      channel.postMessage({ type, payload, timestamp: Date.now() });
    } catch (e) {
      console.error('IPC broadcast error:', e);
    }
  }
}

export function subscribeIPCEvent(callback) {
  const channel = getIPCChannel();
  if (!channel) return () => {};

  const listener = (event) => {
    if (event.data && event.data.type) {
      callback(event.data);
    }
  };

  channel.addEventListener('message', listener);
  return () => {
    channel.removeEventListener('message', listener);
  };
}
